import {
    Box,
    Image,
    Badge,
    Text,
    Stack,
    Heading,
    Flex,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import React from "react";
import { IEventProps } from "../../model.ts";
import { BaseUrl } from "../../const.ts";
import { LinkIcon, ViewIcon } from "@chakra-ui/icons";
import { OnlineIcon } from "../../icons/OnlineIcon.tsx";
import { InpersonIcon } from "../../icons/InpersonIcon.tsx";
import { LocationIcon } from "../../icons/LocationIcon.tsx";
import { useTranslation } from "react-i18next"; // Import useTranslation

const CardItem: React.FC<IEventProps> = ({
                                             idEvent,
                                             coverPhoto,
                                             eventName,
                                             ticketType,
                                             ticketCost,
                                             attendanceTypeEnum,
                                             startDate,
                                             viewCount,
                                         }) => {
    const { t } = useTranslation(); // Initialize useTranslation

    return (
        <Box
            key={idEvent}
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="0px 10px 25px rgba(0, 0, 0, 0.04)"
            _hover={{ boxShadow: "xl", transform: "scale(1.05)" }}
            transition="all 0.3s ease-in-out"
            maxW="sm"
            mb={8}
            mx={2}
            position="relative"
            bg="white"
        >
            {/* Link wrapping the image */}
            <Link to={`/${idEvent}`}>
                <Image
                    src={`${BaseUrl}/images/${coverPhoto}`}
                    alt={eventName}
                    w="100%"
                    h="250px"
                    objectFit="cover"
                    transition="transform 0.3s ease-in-out"
                    _hover={{ transform: "scale(1.05)" }}
                />
                <Box position="absolute" top="215px" left="2" display="flex" gap="4px">
                    <Badge
                        bg={
                            ticketType === "OTHER"
                                ? "white"
                                : ticketType === "FREE"
                                    ? "green.500"
                                    : "#C9B16B"
                        }
                        color={ticketType === "OTHER" ? "#2485D0" : "white"}
                        px="8px"
                        py="4px"
                        borderRadius="5px"
                    >
                        {ticketType === "PAID" ? (
                            `${ticketCost}  ₼`
                        ) : ticketType === "OTHER" ? (
                            <Flex alignItems="center">
                                <LinkIcon mr={2} h="20px" w="20px" color="#2485D0" /> {t("OTHER")} {/* Translation for OTHER */}
                            </Flex>
                        ) : (
                            t(ticketType) // Translation for FREE or other ticket types
                        )}
                    </Badge>
                    <Badge
                        bg="gray.800"
                        color="white"
                        px="8px"
                        py="4px"
                        borderRadius="5px"
                    >
                        {attendanceTypeEnum === "ONLINE" ? (
                            <OnlineIcon />
                        ) : (
                            <InpersonIcon />
                        )}
                        <Box as="span" ml={2}>
                            {attendanceTypeEnum === "ONLINE" ? t("Online") : t("In Person")} {/* Translation for Online/In Person */}
                        </Box>
                    </Badge>
                    <Badge
                        bg="#504a4b"
                        color="white"
                        px="8px"
                        py="4px"
                        borderRadius="5px"
                    >
                        <Flex align="center">
                            <ViewIcon width="16px" mr={2} h="16px" />
                            <Text>{viewCount}</Text>
                        </Flex>
                    </Badge>
                </Box>
            </Link>

            {/* Container for badges and content */}
            <Box p={4} bg="#fff" position="relative">
                {/* Badges for ticket type and attendance type */}

                {/* Content section */}
                <Stack mt="4" spacing="4">
                    {/* Event title */}
                    <Link to={`/${idEvent}`}>
                        <Heading
                            size="md"
                            pb="2"
                            color="#2d373c"
                            fontWeight="700"
                            fontFamily="Euclid Circular B, sans-serif"
                            fontSize="21px"
                            lineHeight="30px"
                            _hover={{ textDecoration: "underline", color: "blue.600" }}
                            transition="color 0.3s"
                        >
                            {eventName}
                        </Heading>
                    </Link>

                    {/* Date and location section */}
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {/* Event date */}
                        <Box display="flex" alignItems="center" color="gray.600">
                            <i
                                className="bi bi-calendar2-week"
                                style={{ marginRight: "6px" }}
                            />
                            <Text fontSize="14px">{startDate}</Text>
                        </Box>
                        {/* Location information */}
                        <Box display="flex" alignItems="center" gap="6px">
                            <LocationIcon />
                            <Text fontSize="14px">{t("Azerbaijan")}</Text> {/* Translation for Azerbaijan */}
                        </Box>
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
};

export default CardItem;
